import i18n from "@/i18n/index";
export default class DataRegions {
}
DataRegions.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/regions",
        text: i18n.t("breadcrumbs.regions"),
        disabled: true,
    },
];
DataRegions.RegionCreateBreadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/regions",
        exact: true,
        text: i18n.t("breadcrumbs.regions"),
    },
    {
        to: "/secure/regions/create",
        text: i18n.t("breadcrumbs.roaming_create"),
        disabled: true,
    },
];
DataRegions.RegionEditBreadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/secure/regions",
        exact: true,
        text: i18n.t("breadcrumbs.regions"),
    },
    {
        to: "/secure/regions/edit",
        text: i18n.t("breadcrumbs.regions_edit"),
        disabled: true,
    },
];
DataRegions.TableHeaders = [
    {
        text: i18n.t("table_headers.sorting"),
        value: "order",
    },
    {
        text: i18n.t("table_headers.region_name"),
        value: "region_name"
    },
    {
        text: i18n.t("table_headers.delivery_method"),
        value: "delivery"
    },
    {
        text: i18n.t("table_headers.region_iso"),
        value: "iso_code"
    },
    {
        text: i18n.t("table_headers.region_cdek_point"),
        value: "cdek_point"
    },
    {
        text: i18n.t("table_headers.region_latitude"),
        value: "latitude"
    },
    {
        text: i18n.t("table_headers.region_longitude"),
        value: "longitude"
    },
    {
        text: i18n.t("table_headers.action"),
        value: "action",
    },
];
